import { createAction, handleActions } from 'redux-actions';
import { Api } from '../../api/api';
import { logout, onForbidden } from '../account/login';
import _ from 'lodash';
import { getOrganizationData } from '../organization/organizations';

//- Actions
export const fetchPriceByOrgTypeAndCountryFailed = createAction('FETCH_GET_PRICE_BY_ORG_TYPE_AND_COUNTRY_FAILED');
export const fetchPriceByOrgTypeAndCountrySuccess = createAction('FETCH_GET_PRICE_BY_ORG_TYPE_AND_COUNTRY_SUCCESS');
export const fetchGetPriceByOrgTypeAndCountry = createAction(
    'FETCH_GET_PRICE_BY_ORG_TYPE_AND_COUNTRY',
    (orgType, countryCode) => Api.getPriceByOrgTypeAndCountry(orgType, countryCode),
    () => ({
        apiCall: true,
        onSuccess: fetchPriceByOrgTypeAndCountrySuccess,
        onFail: fetchPriceByOrgTypeAndCountryFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const fetchGetPresetsFailed = createAction('FETCH_GET_PRESETS_FAILED');
export const fetchGetPresetsSuccess = createAction('FETCH_GET_PRESETS_SUCCESS');
export const fetchGetPresets = createAction(
    'FETCH_GET_PRESETS',
    () => Api.getPresets(),
    () => ({
        apiCall: true,
        onSuccess: fetchGetPresetsSuccess,
        onFail: fetchGetPresetsFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const setDefaultCurrencyAndPricingPreset = () => (dispatch, getState) => {
    let data = getOrganizationData(getState());
    dispatch(setCurrentPreset(_.get(data, "pricing.pricingPreset.id")));
    dispatch(setDefaultCurrency(_.get(data, "balance.currency")));
};

export const setCurrentPreset = createAction('SET_CURRENT_PRESET');
export const setDefaultCurrency = createAction('SET_DEFAULT_CURRENCY');

//- State
const initialState = {
    presetsData: null,
    currentPresetId: null,
    defaultCurrency: null,
    error: null,
    fetching: false
};

//- Reducers
export default handleActions({

    FETCH_GET_PRICE_BY_ORG_TYPE_AND_COUNTRY: (state) => {
        return { ...state, currentPresetId: null,  defaultCurrency: null, error: null, fetching: true };
    },
    FETCH_GET_PRICE_BY_ORG_TYPE_AND_COUNTRY_FAILED: (state, action) => {
        return { ...state, currentPresetId: null,  defaultCurrency: null, error: action.payload, fetching: false };
    },
    FETCH_GET_PRICE_BY_ORG_TYPE_AND_COUNTRY_SUCCESS: (state, action) => {
        return { ...state, currentPresetId: action.payload.pricingPreset.id, defaultCurrency: action.payload.currency, error: null, fetching: false };
    },
    FETCH_GET_PRESETS: (state) => {
        return { ...state, presetsData: null, error: null, fetching: true };
    },
    FETCH_GET_PRESETS_FAILED: (state, action) => {
        return { ...state, presetsData: null, error: action.payload, fetching: false };
    },
    FETCH_GET_PRESETS_SUCCESS: (state, action) => {
        return { ...state, presetsData: action.payload, error: null, fetching: false };
    },
    SET_CURRENT_PRESET: (state, action) => {
        return { ...state, currentPresetId: action.payload };
    },
    SET_DEFAULT_CURRENCY: (state, action) => {
        return { ...state, defaultCurrency: action.payload };
    }

}, initialState);

//- Selectors
export const getFinance = state => state.finance;

export const getPresetsData = state => getFinance(state).presetsData;

export const getCurrentPresetId = state => getFinance(state).currentPresetId;

export const getDefaultCurrency = state => getFinance(state).defaultCurrency;

export const getCurrentPresetData = state => {
    let data = getPresetsData(state);
    let currentPresetId = getCurrentPresetId(state);

    return _.find(data, (elem) => elem.id === currentPresetId);
};


// WEBPACK FOOTER //
// ./src/reducers/finance/finance.js